// jshint esversion: 8

export default {
  id: null,
  location: null,
  name: null,
  operator: null
}
